import { Stack } from "expo-router";

/**
 * User profile stack layout
 * Handles viewing other user profiles
 */
export default function UserProfileLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="[id]" />
    </Stack>
  );
}

